export default "__VITE_ASSET__dbdddb7e__"